import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            // Keep in sync with --color-primary / --color-primary-dark in src/index.css
            main: "#3A9AD5",
            dark: "#2E7DB5",
            contrastText: "#ffffff",
        },
    },
    typography: {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        fontSize: 14,
        body1: { fontSize: 14, fontWeight: 400 },
        body2: { fontSize: 13, fontWeight: 400 },
        subtitle1: { fontSize: 14, fontWeight: 600 },
        subtitle2: { fontSize: 13, fontWeight: 600 },
        caption: { fontSize: 12, fontWeight: 400 },
        h6: { fontSize: 16, fontWeight: 600 },
        button: { fontSize: 14, fontWeight: 600, textTransform: "none" },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                    textTransform: "none",
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: { fontSize: 13 },
                head: { fontSize: 13, fontWeight: 600 },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: { fontSize: 14 },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: { fontSize: 14 },
            },
        },
    },
});

export default theme;
